import React, { useState, useEffect, useRef } from "react";

import { Spinner, Alert } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

import TrashIcon from "./img/trash.webp";

import Eskalationsdatum from "./Eskalationsdatum";
import KachelNotizMenu from "./KachelNotizMenu";
import KachelDateiMenu from "./KachelDateiMenu";
import KachelRestMenu from "./KachelRestMenu";
import KachelForm from "./KachelForm";
import ConfirmButton from "./ConfirmButton";
import { invisiblestring, statusfarben, eskalationsLevel } from "./globalVariables";
import { EditKachel } from "./Settings/EditKachel";

function Kachel({
   setShowAll,
   showAll,
   allKacheln,
   setAllKacheln,
   sendData,
   data,
   changeData,
   eskstatus,
   setEskStatus,
   selectedkachel,
   changeEskStatus,
   kachelData,
   loadSharepointData,
   createOOTask,
   estateId,
   loading,
   projektstufe,
   user,
   sharepointObject,
   sharepointIDs,
   notizen,
   fieldconfiguration,
   sendCommentsandNotes,
   handleElementBlock,
   currentElement,
   blockedField,
   teamsChannelNotification,
   userlist,
   userObjects,
   kachelAbschliessen,
   removeKachel,
}) {
   const [statusColor, setStatusColor] = useState("white");
   const [editLayout, setEditLayout] = useState(false);

   useEffect(() => {
      // Kachelvalidierung
      setStatusColor(
         eskstatus["kachel_status_" + kachelData.kachelId] < eskalationsLevel &&
            kachelData.pflichtEskalation &&
            new Date(eskstatus["kachel_eskalation_" + kachelData.kachelId]) < new Date()
            ? "#c00"
            : statusfarben[eskstatus["kachel_status_" + kachelData.kachelId]],
      );
   }, [data, eskstatus]);

   return (
      <Accordion.Item
         eventKey={kachelData.kachelId}
         style={{
            ...(kachelData.permittedUsers &&
            !(["globaladmin"].includes(user.role) || kachelData.permittedUsers.includes(parseInt(user.id)))
               ? { opacity: 0.4, pointerEvents: "none" }
               : {}),
            ...(selectedkachel === kachelData.kachelId
               ? {
                    transition: "border-color ease 0.7s",
                    border: `solid 4px ${statusColor}`,
                    borderRadius: "6px",
                 }
               : {
                    borderColor: "#dee2e6",
                    borderStyle: selectedkachel ? "none" : "solid",
                 }),
         }}
      >
         {eskstatus && (
            <Accordion.Header
               style={
                  selectedkachel != kachelData.kachelId
                     ? { opacity: selectedkachel ? 0.3 : 1 }
                     : {
                          transition: "background-color ease 0.7s",
                          // borderTop: "solid white 10px",
                          zIndex: 4,
                          position: "sticky",
                          top: "-38px",
                          backgroundColor: statusColor,
                       }
               }
               bsPrefix={""}
            >
               <div
                  className="kachel-status"
                  style={{
                     transition: "background-color ease 1s",
                     backgroundColor: statusColor,
                  }}
               ></div>
               {eskstatus["kachel_status_" + kachelData.kachelId] === 3 && (
                  <span
                     title="Freigabe durch Administrator erforderlich"
                     style={{ backgroundColor: "#000", color: "white" }}
                     className="pm-freigabe"
                  >
                     A
                  </span>
               )}
               {eskstatus["kachel_status_" + kachelData.kachelId] === 2 && (
                  <span
                     title="Freigabe durch Projektmanager erforderlich"
                     style={{ backgroundColor: "#000", color: "white", width: "30px" }}
                     className="pm-freigabe"
                  >
                     P
                  </span>
               )}
               {!(
                  eskstatus["kachel_status_" + kachelData.kachelId] === 2 ||
                  eskstatus["kachel_status_" + kachelData.kachelId] === 3
               ) && (
                  <span className="pm-freigabe" style={{ width: "30px" }}>
                     {invisiblestring}
                  </span>
               )}

               {
                  <span
                     className="kachel-title"
                     style={{
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontWeight: kachelData.pflichtKachel ? "900" : "500",
                        /* backgroundColor: "white", */
                        color: selectedkachel === kachelData.kachelId ? statusColor : "black",
                     }}
                     title={kachelData.pflichtKachel ? "Pflichtkachel" : "Optionale Kachel"}
                  >
                     {data["heading_" + kachelData.kachelId]
                        ? data["heading_" + kachelData.kachelId]
                        : kachelData.heading}
                  </span>
               }
               {kachelData.permittedUsers && (
                  <small>
                     {"Kachel nur für: "}
                     {kachelData.permittedUsers
                        .map(
                           (userItem) =>
                              userObjects[userItem] &&
                              userObjects[userItem].Vorname + " " + userObjects[userItem].Nachname,
                        )
                        .join(", ")}
                  </small>
               )}
               {!selectedkachel && !kachelData.notRemovable && (
                  <ConfirmButton
                     disabled={loading === "loading"}
                     myFunction={() => {
                        removeKachel(projektstufe, kachelData.heading, kachelData);
                     }}
                     myText={"Kachel entfernen: Kann wieder hergestellt werden und Inhalt bleibt erhalten"}
                     myName={""}
                     myIcon={TrashIcon}
                     renderDiv={true}
                     myStyle={{ position: "absolute", right: "10px", border: "none", top: "7px" }}
                     myClassName={"share-button"}
                  />
               )}
               {eskstatus["kachel_status_" + kachelData.kachelId] < eskalationsLevel && (
                  <Eskalationsdatum
                     eskstatus={eskstatus}
                     setEskStatus={setEskStatus}
                     changeEskStatus={changeEskStatus}
                     kachelId={kachelData.kachelId}
                     user={user}
                     estateId={estateId}
                     sendData={sendData}
                     userlist={userlist}
                     createOOTask={createOOTask}
                     sendCommentsandNotes={sendCommentsandNotes}
                  ></Eskalationsdatum>
               )}
            </Accordion.Header>
         )}
         {selectedkachel === kachelData.kachelId && data && eskstatus && (
            <Accordion.Body /* style={editLayout ? { background: "#0001" } : {}} */>
               {editLayout && (
                  <EditKachel
                     data={kachelData}
                     allKacheln={allKacheln}
                     setAllKacheln={setAllKacheln}
                     fieldconfiguration={fieldconfiguration}
                  />
               )}
               <div className="kachel-toolbar">
                  <KachelRestMenu
                     setShowAll={setShowAll}
                     projektstufe={projektstufe}
                     kachelData={kachelData}
                     estateId={estateId}
                     removeKachel={removeKachel}
                     data={data}
                     user={user}
                     changeData={changeData}
                     eskstatus={eskstatus}
                     kachelAbschliessen={kachelAbschliessen}
                     loading={loading}
                     editLayout={editLayout}
                     setEditLayout={setEditLayout}
                  />
                  <KachelDateiMenu
                     kachelData={kachelData}
                     sharepointObject={sharepointObject}
                     sharepointIDs={sharepointIDs}
                     loadSharepointData={loadSharepointData}
                     blockedField={blockedField}
                     currentElement={currentElement}
                     handleElementBlock={handleElementBlock}
                     user={user}
                     notizen={notizen}
                     sendCommentsandNotes={sendCommentsandNotes}
                     loading={loading}
                  />

                  <KachelNotizMenu
                     kachelData={kachelData}
                     estateId={estateId}
                     currentElement={currentElement}
                     blockedField={blockedField}
                     handleElementBlock={handleElementBlock}
                     user={user}
                     notizen={notizen}
                     sendCommentsandNotes={sendCommentsandNotes}
                     loading={loading}
                  />
               </div>

               {kachelData.hinweis && (
                  <Alert variant="success" className="mt-2">
                     <span
                        className="tutorial-text"
                        dangerouslySetInnerHTML={{
                           __html: kachelData.hinweis,
                        }}
                     />
                  </Alert>
               )}
               <KachelForm
                  showAll={showAll}
                  setShowAll={setShowAll}
                  allKacheln={allKacheln}
                  setAllKacheln={setAllKacheln}
                  sendData={sendData}
                  data={data}
                  changeData={changeData}
                  eskstatus={eskstatus}
                  changeEskStatus={changeEskStatus}
                  kachelData={kachelData}
                  createOOTask={createOOTask}
                  estateId={estateId}
                  loading={loading}
                  currentElement={currentElement}
                  user={user}
                  handleElementBlock={handleElementBlock}
                  blockedField={blockedField}
                  teamsChannelNotification={teamsChannelNotification}
                  userlist={userlist}
                  fieldconfiguration={fieldconfiguration}
                  editLayout={editLayout}
                  sharepointObject={sharepointObject}
                  loadSharepointData={loadSharepointData}
               />
            </Accordion.Body>
         )}
      </Accordion.Item>
   );
}

export default Kachel;
